import { render, staticRenderFns } from "./ESwitch.vue?vue&type=template&id=3c1ae398&scoped=true"
import script from "./ESwitch.vue?vue&type=script&lang=js"
export * from "./ESwitch.vue?vue&type=script&lang=js"
import style0 from "./ESwitch.vue?vue&type=style&index=0&id=3c1ae398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1ae398",
  null
  
)

export default component.exports